<template>
  <div>
    <div class="container">
      <e-search
        :count="filterInfo.count"
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      >
      </e-search>
    </div>
    <div class="container">
      <!-- <div class="crumbs">
				<el-breadcrumb separator=" ">
					<el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 采购订单列表 </el-breadcrumb-item>
				</el-breadcrumb>
			</div> -->
      <table-list :table-data="tableData" :table-label="tableLabel">
        <template v-slot:operate="slot">
          <div class="operate" v-if="slot.scope.row.skuJson">
            <div @click="handleButton(slot.scope.row, 'orderDetail')">
              订单明细
            </div>
            <div @click="handleButton(slot.scope.row, 'record')">
              订单操作记录
            </div>
          </div>
        </template>
      </table-list>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="orderTagPage.currentPage"
          :page-size="orderTagPage.pageSize"
          :total="orderTagPage.pageTotal"
          prev-text="上一页"
          next-text="下一页"
        >
        </el-pagination>
      </div>
      <el-dialog
        :title="dialogTitle"
        :modal-append-to-body="false"
        :visible.sync="dialogTableVisible"
      >
        <table-list
          v-show="dialogTitle == '订单明细'"
          :table-data="orderDetailList"
          :table-label="detaileLabel"
        >
          <template v-slot:productName="slot">
            <el-tooltip
              class="item"
              effect="dark"
              :content="slot.scope.row.productName"
              placement="top"
            >
              <div class="break-two">{{ slot.scope.row.productName }}</div>
            </el-tooltip>
          </template>
          <template v-slot:displaySkuOptions="slot">
            <el-tooltip
              class="item"
              effect="dark"
              :content="slot.scope.row.displaySkuOptions"
              placement="top"
            >
              <div class="break-two">
                {{ slot.scope.row.displaySkuOptions }}
              </div>
            </el-tooltip>
          </template>
        </table-list>
        <table-list
          v-show="dialogTitle == '订单操作记录'"
          :table-data="recordData"
          :table-label="recordLabel"
        />
        <!-- <div class="pagination" v-show="dialogTitle =='订单明细'">
					<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]" layout="total, sizes, prev, pager, next, jumper"
						prev-text="上一页" next-text="下一页">
					</el-pagination>
				</div> -->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import api from '../../api/order';
import tableList from '../../components/common/e-table-list';
import eSearch from '../../components/common/e-search';
import utils from '@/modules/projectA/utils/utils';
export default {
  name: 'orderManage',
  components: {
    tableList,
    eSearch,
  },
  data() {
    return {
      listTypeInfo: {
        typeList: [
          {
            id: '',
            name: '普通订单',
          },
          {
            id: 5,
            name: '询比价订单',
          },
        ],
        statusList: [
          {
            id: 17,
            name: '待供应商确认',
          },
          {
            id: 18,
            name: '待采购商确认',
          },
          {
            id: 12,
            name: '待审批',
          },
          {
            id: 72,
            name: '变更中',
          },
          {
            id: 21,
            name: '待付款',
          },
          {
            id: 104,
            name: '付款中',
          },
          {
            id: 32,
            name: '待发货',
          },
          {
            id: 4,
            name: '待收货',
          },
          {
            id: 8,
            name: '待评价',
          },
          {
            id: 6,
            name: '交易完成',
          },
        ],
      },
      filterInfo: {
        data: {
          orderNo: null,
          supplierCompany: null, //供应商名称
          orderType: '',
          startAmount: null,
          endAmount: null,
          orderStatus: null,
          orgShortName: null,
          memberRealName: null,
          submitTime: null,
          startTime: null,
          endTime: null,
        },
        fieldList: [
          {
            label: '订单编号',
            type: 'input',
            value: 'orderNo',
          },
          {
            label: '供应商名称',
            type: 'input',
            value: 'supplierCompany',
          },
          {
            label: '订单类型',
            type: 'select',
            value: 'orderType',
            list: 'typeList',
          },

          {
            label: '订单状态',
            type: 'select',
            value: 'orderStatus',
            list: 'statusList',
          },
          {
            label: '下单部门',
            type: 'input',
            value: 'orgShortName',
          },
          {
            label: '下单人',
            type: 'input',
            value: 'memberRealName',
          },
          {
            label: '下单时间',
            type: 'date',
            value: 'submitTime',
            dateType: "datetimerange",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            defaultTime: ["00:00:00", "23:59:59"],
          },
          {
            label: '价格范围',
            type: 'numRange', // priceRange
            value1: 'startAmount',
            value2: 'endAmount',
            rangeWidth: 'min-width',
          },
        ],
        count: 100,
        btnStyle: [
          {
            icon: 'el-icon-refresh',
            text: '重置',
          },
          {
            icon: 'el-icon-search',
            text: '查询',
            type: 'primary',
          },
        ],
      },
      tableLabel: [
        { label: '订单编号', param: 'orderNo', align: 'center' },
        // {
        // 	prop="suppConfirmName" label="供应商联系人" prop="suppConfirmMobile" label="供应商联系电话"
        // }
        { label: '供应商名称', param: 'supplierCompany', align: 'center' },
        {
          label: '订单状态',
          param: 'orderStatus',
          align: 'center',
          render: (row) => {
            if (row.orderStatus === 17) {
              return '待供应商确认';
            } else if (row.orderStatus === 18) {
              return '待采购商确认';
            } else if (row.orderStatus === 12) {
              return '待审批';
            } else if (row.orderStatus === 72) {
              return '变更中';
            } else if (row.orderStatus === 21 || row.orderStatus === 22) {
              return '待付款';
            } else if (row.orderStatus === 104) {
              return '付款中';
            } else if (row.orderStatus === 32 || row.orderStatus === 31) {
              return '待发货';
            } else if (row.orderStatus === 8) {
              return '待评价';
            } else if (row.orderStatus === 6) {
              return '交易完成';
            } else if (row.orderStatus === 4) {
              return '待收货';
            } else if (row.orderStatus === 7) {
              return '已取消';
            } else if (row.orderStatus === 103) {
              return '溢装待付款';
            } else if (row.orderStatus === 71) {
              return '取消中';
            }
          },
        },
        { label: '订单金额(含运杂费)', param: 'needPay', align: 'center' },
        { label: '运杂费', param: 'shippingCost', align: 'center' },
        { label: '下单部门', param: 'orgShortName', align: 'center' },
        { label: '下单人', param: 'memberRealName', align: 'center' },
        { label: '下单人账号', param: 'memberName', align: 'center' },
        { label: '下单时间', param: 'submitTime', align: 'center' },
        { label: '要求到货日期', param: 'arriveTimeTxt', align: 'center' },
        { label: '订单付款时间', param: 'paymentTime', align: 'center' },
        { label: '操作', param: 'operate', align: 'center', slot: 'operate' },
      ],
      detaileLabel: [
        {
          label: '商品名称',
          param: 'productName',
          align: 'center',
          slot: 'productName',
        },
        // {
        // 	label: '商品类别',
        // 	param: 'brandName',
        // 	align: 'center'
        // },
        {
          label: '供应商名称',
          param: 'supplierCompany',
          align: 'center',
        },
        {
          label: '数量',
          param: 'quantity',
          align: 'center',
        },
        {
          label: '基本计量单位',
          param: 'goodsUnitName',
          align: 'center',
        },
        {
          label: '价格',
          param: 'price',
          align: 'center',
        },
        {
          label: '规格描述',
          param: 'displaySkuOptions',
          align: 'center',
          slot: 'displaySkuOptions',
        },
      ],
      recordLabel: [
        {
          label: '订单状态',
          param: 'operateType',
          align: 'center',
        },
        {
          label: '操作人',
          param: 'memberRealName',
          align: 'center',
        },
        {
          label: '联系电话',
          param: 'memberMobile',
          align: 'center',
          width: '110px',
        },
        {
          label: '订单编号',
          param: 'keyMessage',
          align: 'center',
          width: '200px',
        },
        {
          label: '操作时间',
          param: 'logTime',
          align: 'center',
          width: '160px',
        },
      ],
      dialogTitle: '订单操作记录',
      dialogTableVisible: false,
      status: [
        {
          value: '17',
          label: '待供应商确认',
        },
        {
          value: '18',
          label: '待采购商确认',
        },
        {
          value: '12',
          label: '待审批',
        },
        {
          value: '72',
          label: '变更中',
        },
        {
          value: '21',
          label: '待付款',
        },
        {
          value: '104',
          label: '付款中',
        },
        {
          value: '32',
          label: '待发货',
        },
        {
          value: '4',
          label: '待收货',
        },
        {
          value: '8',
          label: '待评价',
        },
        {
          value: '6',
          label: '交易完成',
        },
      ],
      query: {
        orderNo: null,
        supplierCompany: null, //供应商名称
        orderType: null,
        startAmount: null,
        endAmount: null,
        orderStatus: null,
        orgShortName: null,
        memberRealName: null,
        startTime: null,
        endTime: null,
      },
      tableData: [],
      recordData: [],
      orderTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      orderDetailList: [],
    };
  },
  created() {
    console.log(utils.isEmptyObject(this.$route.query));
    if (!utils.isEmptyObject(this.$route.query)) {
      this.filterInfo.data.supplierCompany = this.$route.query.supplier;
      this.query.supplierCompany = this.$route.query.supplier;
    }
    this.queryOrderList();
  },
  methods: {
    handleFilter(val) {
      if (val.submitTime) {
        this.query.startTime = val.submitTime
          ? utils.parseTime(val.submitTime[0])
          : '';
        this.query.endTime = val.submitTime
          ? utils.parseTime(val.submitTime[1])
          : '';
      } else {
        this.query.startTime = null;
        this.query.endTime = null;
      }

      this.query.orderNo = val.orderNo;
      this.query.orderType = val.orderType;
      this.query.orderStatus = val.orderStatus;
      this.query.supplierCompany = val.supplierCompany;
      this.query.orgShortName = val.orgShortName;
      this.query.memberRealName = val.memberRealName;
      this.query.startAmount = val.startAmount;
      this.query.endAmount = val.endAmount;
      api.queryPurchaseOrderListByPage(this.query).then((res) => {
        if (res.code == '200') {
          this.tableData = res.data.records;
          this.orderTagPage.pageTotal = res.data.total;
        } else {
          this.tableData = [];
          this.$message.error(res.message);
        }
      });
    },
    handleReset() {
      this.query.orderType = '';
      this.query.orderStatus = null;
      this.query.startAmount = null;
      this.query.endAmount = null;
      this.query.memberRealName = null;
      this.query.orgShortName = null;
      this.query.supplierCompany = null;
      this.query.orderNo = null;
      this.query.startTime = null;
      this.query.endTime = null;
      this.query.submitTime = null;
      this.filterInfo.data.supplierCompany = null;
      this.queryOrderList();
    },
    //   导出
    exportDetail() {
      // this.$message.success("二期内容");
    },
    dataFormate(time) {
      let arr = (
        time.getFullYear() +
        '-' +
        (time.getMonth() + 1) +
        '-' +
        time.getDate()
      ).split('-');
      if (arr[1].length == 1) {
        arr[1] = '0' + arr[1];
      }
      if (arr[2].length == 1) {
        arr[2] = '0' + arr[2];
      }
      return arr[0] + '-' + arr[1] + '-' + arr[2];
    },
    handleSizeChange(pageSize) {
      this.orderTagPage.pageSize = pageSize;
      this.queryOrderList();
    },
    handleCurrentChange(currentPage) {
      this.orderTagPage.currentPage = currentPage;
      this.queryOrderList();
    },
    handleButton(val, flag) {
      let orderId = val.orderId;
      let orderNo = val.orderNo;
      if (flag === 'orderDetail') {
        this.dialogTitle = '订单明细';
        this.queryPurchaseOrderSkuListByPage(orderId);
      }
      if (flag === 'record') {
        this.dialogTitle = '订单操作记录';
        this.queryPurchaseOrderLogByPage(orderNo);
      }
      this.dialogTableVisible = true;
    },
    queryOrderList() {
      let params = {
        pageNum: this.orderTagPage.currentPage,
        pageSize: this.orderTagPage.pageSize,
        orderNo: this.query.orderNo,
        orderType: this.query.orderType,
        orderStatus: this.query.orderStatus,
        supplierCompany: this.query.supplierCompany,
        orgShortName: this.query.orgShortName,
        memberRealName: this.query.memberRealName,
        startAmount: this.query.startAmount,
        endAmount: this.query.endAmount,
        startTime: this.query.startTime,
        endTime: this.query.endTime,
      };

      api.queryPurchaseOrderListByPage(params).then((res) => {
        if (res.code == '200') {
          this.tableData = res.data.records;
          this.orderTagPage.pageTotal = res.data.total;
        } else {
          this.tableData = [];
          this.$message('暂无数据。');
          this.$message.error(res.message);
        }
      });
    },
    formatParams() {
      let res = {};
      res.pageNum = this.productTagPage.currentPage;
      res.pageSize = this.productTagPage.pageSize;
      res.agreementId = this.agreementId;
      res.skuName = this.query.skuName;
      res.skuCode = this.query.skuCode;
      res.userIdentity = this.userIdentity == 2 ? 'purchase' : '';
      res.supplierCompanyId = this.supplierCompanyId;
      return res;
    },
    /*
				导出
				const params = {};
				Object.assign(params, this.listQuery);
				params.pageSize = this.total;
				console.log(params);
				const res = await api.downProductList(params);
				if (res.size !== 0) {
				  utils.downFile(res);
				}
			*/
    queryPurchaseOrderLogByPage(orderNo) {
      api
        .queryPurchaseOrderLogByPage({
          orderNo: orderNo,
        })
        .then((res) => {
          if (res.code == 200) {
            this.recordData = res.data.records;
          } else {
            this.recordData = [];
          }
        });
    },
    queryPurchaseOrderSkuListByPage(orderId) {
      api
        .queryPurchaseOrderSkuListByPage({
          orderId: orderId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.orderDetailList = res.data.records;
          }
          console.log(res);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.min-width {
  width: 110px;
  z-index: 10000;
}
.operate {
  div {
    color: #2d8cf0;
    font-size: 12px;
    cursor: pointer;
  }
}

.span-s {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5px;
  text-decoration: none;
  color: rgb(37, 135, 255);
  border: 1px solid rgb(37, 135, 255);
  width: 80px;
  height: 30px;
  font-size: 14px;
}

.span-s:nth-child(1) {
  border: 1px solid rgb(220, 223, 230);
  margin-right: 10px;
  color: rgb(51, 51, 51);
}

.span-s:hover {
  background-color: rgb(232, 239, 255);
  color: rgb(37, 135, 255);
}

.exportOrder {
  text-decoration: none;
  color: rgb(37, 135, 255);
  border: 1px solid rgb(37, 135, 255);
  padding: 9px 15px;
  font-size: 12px;
}

.exportOrder:nth-child(1) {
  margin-right: 5px;
}

.exportOrder:hover {
  background-color: rgb(233, 243, 255);
}

.order-s {
  color: #0064c8;
  cursor: pointer;
}

.order-s:hover {
  // text-decoration: underline;
}

.mk10 {
  width: 160px !important;
}

.mt10 {
  width: 360px;
}

.pagination {
  text-align: right;
}
.break-two {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
